import { ToggleButton, ToggleButtonChangeEvent } from "primereact/togglebutton";

interface REIToggleButtonProps {
  id?: string;
  testId?: string;
  onlabel: string;
  offlabel: string;
  isSelected: boolean;
  onToggleChange: (event: ToggleButtonChangeEvent) => void;
  customclass?: string;
  index: string;
}

const REIToggleButton: React.FC<REIToggleButtonProps> = ({
  id,
  testId,
  onlabel,
  offlabel,
  isSelected,
  onToggleChange,
  customclass,
  index,
}) => {
  return (
    <ToggleButton
      onLabel={onlabel}
      offLabel={offlabel}
      checked={isSelected}
      onChange={onToggleChange}
      className={customclass}
      key={index}
      id={id ?? index.toString()}
      data-testid={testId ?? id ?? index.toString()}
    />
  );
};

export default REIToggleButton;
